import { useFormat } from '@ideavivat/vivat-2';
import useWithdraw from '@/use/useWithdraw';

import { materialBrand } from './base';

function toCurrency(val: string) {
  return parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    bom_item: {
      name: 'Job Sub',
      width: '6rem',
      filter: (val: any) => `${val?.job_no || ''}`,
    },
    production_type: {
      name: 'ประเภท',
      width: '5rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item?.bom_item?.production_type || '',
    },
    material: {
      name: 'รหัสชิ้นส่วน',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item?.bom_item?.material?.code || '',
    },
    description: {
      name: 'รายละเอียด',
      width: '1fr',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item?.bom_item?.description || '',
    },
    materialBrand,
    drawing_no: {
      name: 'Drawing No./Part No.',
      width: '10rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => row.item?.bom_item?.drawing_no || '',
    },
    amount: {
      name: 'จำนวนที่ขอเบิก',
      width: '7rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => toCurrency(val || '0'),
    },
    filled_amount: {
      name: 'เบิกไปแล้ว',
      width: '5rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => toCurrency(val || '0'),
    },
    unit: {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-center',
    },
  },
};
